// extracted by mini-css-extract-plugin
export var filterButton = "_ot-1";
export var filtersContainer = "_ot-0";